var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"content",style:({paddingTop: _vm.HEADER_HEIGHT})},[_c('SectionFirstScreen'),_c('SectionIcons'),_c('SectionAbout'),_c('SectionFocus'),_c('SectionStatistic'),_c('SectionProjects'),_c('SectionContact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }